import { render, staticRenderFns } from "./no_group.vue?vue&type=template&id=3b6c8eec&scoped=true"
import script from "./no_group.vue?vue&type=script&lang=js"
export * from "./no_group.vue?vue&type=script&lang=js"
import style0 from "./no_group.vue?vue&type=style&index=0&id=3b6c8eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c8eec",
  null
  
)

export default component.exports